import React, { useEffect } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

/* ─── Yardımcı bileşenler ─── */

const LpTable = ({ caption, headers, rows }) => (
  <div className="lp-table-wrap">
    <table className="lp-table">
      <caption>{caption}</caption>
      <thead>
        <tr>{headers.map(h => <th key={h} scope="col">{h}</th>)}</tr>
      </thead>
      <tbody>
        {rows.map((row, ri) => (
          <tr key={ri}>
            {row.map((cell, ci) =>
              ci === 0
                ? <th key={ci} scope="row">{cell}</th>
                : <td key={ci}>{cell}</td>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

const tariffNotice = 'Bu örnek belirli bir tarife ve dönem üzerinden hazırlanmıştır. Kademe sınırları, birim fiyatlar, vergiler ve diğer fatura kalemleri dönemsel olarak değişebilir. Güncel hesaplama sistemde tanımlı tarife bilgilerine göre yapılır.';

/* ─── Komşu Sayaç SVG Şeması ─── */
const NeighborMeterDiagram = () => (
  <svg viewBox="0 0 480 260" className="lp-svg-diagram" xmlns="http://www.w3.org/2000/svg" aria-label="Komşu süzme sayaç bağlantı şeması">
    <defs>
      <linearGradient id="cableGrad" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#3177a8" />
        <stop offset="100%" stopColor="#7a62bd" />
      </linearGradient>
      <filter id="glow">
        <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
        <feMerge><feMergeNode in="coloredBlur"/><feMergeNode in="SourceGraphic"/></feMerge>
      </filter>
    </defs>

    {/* Ana bina */}
    <rect x="30" y="80" width="140" height="120" rx="8" fill="rgba(49,119,168,0.15)" stroke="rgba(49,119,168,0.5)" strokeWidth="1.5"/>
    <polygon points="30,80 100,30 170,80" fill="rgba(49,119,168,0.25)" stroke="rgba(49,119,168,0.5)" strokeWidth="1.5"/>
    {/* Kapı */}
    <rect x="85" y="150" width="30" height="50" rx="4" fill="rgba(49,119,168,0.3)" stroke="rgba(49,119,168,0.4)" strokeWidth="1"/>
    {/* Pencere */}
    <rect x="45" y="110" width="30" height="25" rx="3" fill="rgba(96,180,244,0.2)" stroke="rgba(96,180,244,0.5)" strokeWidth="1"/>
    <rect x="125" y="110" width="30" height="25" rx="3" fill="rgba(96,180,244,0.2)" stroke="rgba(96,180,244,0.5)" strokeWidth="1"/>
    <text x="100" y="75" textAnchor="middle" fill="#7ab8d8" fontSize="10" fontFamily="Inter,sans-serif" fontWeight="600">Ana Bina</text>

    {/* Ana Sayaç Kutusu */}
    <rect x="170" y="110" width="60" height="45" rx="6" fill="rgba(49,119,168,0.2)" stroke="#3177a8" strokeWidth="2" filter="url(#glow)"/>
    <rect x="178" y="118" width="44" height="20" rx="3" fill="rgba(96,180,244,0.15)" stroke="rgba(96,180,244,0.3)" strokeWidth="1"/>
    <text x="200" y="130" textAnchor="middle" fill="#60b4f4" fontSize="7.5" fontFamily="monospace" fontWeight="700">300 kWh</text>
    <text x="200" y="168" textAnchor="middle" fill="#7ab8d8" fontSize="9" fontFamily="Inter,sans-serif" fontWeight="700">Ana Sayaç</text>

    {/* Komşu bina */}
    <rect x="290" y="120" width="110" height="80" rx="8" fill="rgba(122,98,189,0.15)" stroke="rgba(122,98,189,0.5)" strokeWidth="1.5"/>
    <polygon points="290,120 345,80 400,120" fill="rgba(122,98,189,0.25)" stroke="rgba(122,98,189,0.5)" strokeWidth="1.5"/>
    {/* Kapı */}
    <rect x="322" y="158" width="22" height="42" rx="3" fill="rgba(122,98,189,0.3)" stroke="rgba(122,98,189,0.4)" strokeWidth="1"/>
    {/* Pencere */}
    <rect x="299" y="135" width="22" height="18" rx="2" fill="rgba(167,139,250,0.2)" stroke="rgba(167,139,250,0.4)" strokeWidth="1"/>
    <rect x="368" y="135" width="22" height="18" rx="2" fill="rgba(167,139,250,0.2)" stroke="rgba(167,139,250,0.4)" strokeWidth="1"/>
    <text x="345" y="113" textAnchor="middle" fill="#b8a4ee" fontSize="10" fontFamily="Inter,sans-serif" fontWeight="600">Komşu</text>

    {/* Süzme Sayaç Kutusu */}
    <rect x="400" y="130" width="55" height="40" rx="6" fill="rgba(122,98,189,0.2)" stroke="#7a62bd" strokeWidth="2" filter="url(#glow)"/>
    <rect x="407" y="137" width="40" height="16" rx="3" fill="rgba(167,139,250,0.15)" stroke="rgba(167,139,250,0.3)" strokeWidth="1"/>
    <text x="427" y="148" textAnchor="middle" fill="#a78bfa" fontSize="7" fontFamily="monospace" fontWeight="700">150 kWh</text>
    <text x="427" y="183" textAnchor="middle" fill="#b8a4ee" fontSize="8.5" fontFamily="Inter,sans-serif" fontWeight="700">Süzme Sayaç</text>

    {/* Hat: Şebeke → Ana Sayaç */}
    <line x1="10" y1="132" x2="170" y2="132" stroke="url(#cableGrad)" strokeWidth="3" strokeLinecap="round"/>
    {/* Şebeke simgesi */}
    <circle cx="10" cy="132" r="8" fill="rgba(49,119,168,0.25)" stroke="#3177a8" strokeWidth="1.5"/>
    <text x="10" y="136" textAnchor="middle" fill="#60b4f4" fontSize="8">⚡</text>
    <text x="90" y="125" textAnchor="middle" fill="#3177a8" fontSize="8.5" fontFamily="Inter,sans-serif">Şebeke Hattı</text>

    {/* Dallanma noktası */}
    <circle cx="230" cy="132" r="5" fill="#3177a8" stroke="#60b4f4" strokeWidth="1.5"/>

    {/* Hat: Dallanma → Komşu binaya (kablo) */}
    <path d="M230,132 Q260,132 260,155 L260,170" stroke="rgba(122,98,189,0.7)" strokeWidth="2" strokeDasharray="5,3" fill="none" strokeLinecap="round"/>
    <line x1="260" y1="170" x2="290" y2="170" stroke="rgba(122,98,189,0.7)" strokeWidth="2" strokeDasharray="5,3" strokeLinecap="round"/>

    {/* Hat: Komşu bina → Süzme sayaç */}
    <line x1="400" y1="150" x2="456" y2="150" stroke="#7a62bd" strokeWidth="2" strokeLinecap="round"/>

    {/* Etiket: dallanma açıklaması */}
    <text x="247" y="148" fill="rgba(122,98,189,0.9)" fontSize="8" fontFamily="Inter,sans-serif">Ayrı Hat</text>

    {/* Alt legend */}
    <rect x="100" y="225" width="12" height="3" rx="1" fill="#3177a8"/>
    <text x="116" y="228" fill="#5a8aaa" fontSize="8.5" fontFamily="Inter,sans-serif">Ana hat</text>
    <line x1="185" y1="227" x2="197" y2="227" stroke="rgba(122,98,189,0.7)" strokeWidth="2" strokeDasharray="4,2"/>
    <text x="202" y="228" fill="#5a8aaa" fontSize="8.5" fontFamily="Inter,sans-serif">Komşu ayrı hattı</text>
  </svg>
);

/* ─── Eşit Kiracı SVG Şeması ─── */
const EqualTenantsDiagram = () => (
  <svg viewBox="0 0 480 230" className="lp-svg-diagram" xmlns="http://www.w3.org/2000/svg" aria-label="Eşit öncelikli iki kiracı şeması">
    <defs>
      <linearGradient id="mainGrad" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#3177a8"/>
        <stop offset="100%" stopColor="#7a62bd"/>
      </linearGradient>
    </defs>

    {/* Bina */}
    <rect x="160" y="40" width="160" height="130" rx="8" fill="rgba(49,119,168,0.1)" stroke="rgba(49,119,168,0.3)" strokeWidth="1.5"/>
    <polygon points="160,40 240,5 320,40" fill="rgba(49,119,168,0.2)" stroke="rgba(49,119,168,0.3)" strokeWidth="1.5"/>
    {/* Bölme çizgisi */}
    <line x1="240" y1="40" x2="240" y2="170" stroke="rgba(255,255,255,0.15)" strokeWidth="1" strokeDasharray="4,3"/>
    {/* Daire A */}
    <rect x="168" y="60" width="65" height="50" rx="4" fill="rgba(49,119,168,0.12)"/>
    <text x="200" y="90" textAnchor="middle" fill="#60b4f4" fontSize="11" fontFamily="Inter,sans-serif" fontWeight="700">Daire A</text>
    <text x="200" y="103" textAnchor="middle" fill="#4a90b8" fontSize="9" fontFamily="Inter,sans-serif">160 kWh</text>
    {/* Daire B */}
    <rect x="247" y="60" width="65" height="50" rx="4" fill="rgba(122,98,189,0.12)"/>
    <text x="280" y="90" textAnchor="middle" fill="#a78bfa" fontSize="11" fontFamily="Inter,sans-serif" fontWeight="700">Daire B</text>
    <text x="280" y="103" textAnchor="middle" fill="#8070c8" fontSize="9" fontFamily="Inter,sans-serif">140 kWh</text>

    {/* Kapılar */}
    <rect x="190" y="128" width="22" height="42" rx="3" fill="rgba(49,119,168,0.25)" stroke="rgba(49,119,168,0.35)" strokeWidth="1"/>
    <rect x="268" y="128" width="22" height="42" rx="3" fill="rgba(122,98,189,0.25)" stroke="rgba(122,98,189,0.35)" strokeWidth="1"/>

    {/* Ana Sayaç */}
    <rect x="207" y="182" width="66" height="40" rx="6" fill="rgba(49,119,168,0.2)" stroke="#3177a8" strokeWidth="2"/>
    <rect x="213" y="188" width="54" height="18" rx="3" fill="rgba(96,180,244,0.1)" stroke="rgba(96,180,244,0.2)" strokeWidth="1"/>
    <text x="240" y="200" textAnchor="middle" fill="#60b4f4" fontSize="7.5" fontFamily="monospace" fontWeight="700">300 kWh</text>
    <text x="240" y="214" textAnchor="middle" fill="#7ab8d8" fontSize="8.5" fontFamily="Inter,sans-serif" fontWeight="600">Ana Sayaç</text>

    {/* Şebeke */}
    <line x1="50" y1="202" x2="207" y2="202" stroke="url(#mainGrad)" strokeWidth="3" strokeLinecap="round"/>
    <circle cx="50" cy="202" r="10" fill="rgba(49,119,168,0.2)" stroke="#3177a8" strokeWidth="1.5"/>
    <text x="50" y="206" textAnchor="middle" fill="#60b4f4" fontSize="10">⚡</text>
    <text x="128" y="195" textAnchor="middle" fill="#3177a8" fontSize="8.5" fontFamily="Inter,sans-serif">Şebeke</text>

    {/* Hat: sayaç → daire A */}
    <line x1="220" y1="182" x2="200" y2="130" stroke="#3177a8" strokeWidth="1.5" strokeDasharray="4,3" strokeLinecap="round"/>
    {/* Hat: sayaç → daire B */}
    <line x1="265" y1="182" x2="280" y2="130" stroke="#7a62bd" strokeWidth="1.5" strokeDasharray="4,3" strokeLinecap="round"/>

    {/* Eşit işareti */}
    <text x="240" y="145" textAnchor="middle" fill="#f0f6ff" fontSize="18" fontWeight="800">=</text>
    <rect x="222" y="130" width="36" height="22" rx="4" fill="rgba(255,255,255,0.06)" stroke="rgba(255,255,255,0.12)" strokeWidth="1"/>

    {/* Süzme sayaç Daire B için */}
    <rect x="330" y="75" width="60" height="38" rx="6" fill="rgba(122,98,189,0.2)" stroke="#7a62bd" strokeWidth="2"/>
    <rect x="337" y="81" width="46" height="16" rx="3" fill="rgba(167,139,250,0.1)" stroke="rgba(167,139,250,0.2)" strokeWidth="1"/>
    <text x="360" y="92" textAnchor="middle" fill="#a78bfa" fontSize="7.5" fontFamily="monospace" fontWeight="700">140 kWh</text>
    <text x="360" y="105" textAnchor="middle" fill="#b8a4ee" fontSize="8" fontFamily="Inter,sans-serif" fontWeight="600">Süzme Sayaç</text>
    <line x1="312" y1="93" x2="330" y2="93" stroke="#7a62bd" strokeWidth="2" strokeLinecap="round"/>

    {/* Etiket */}
    <text x="240" y="20" textAnchor="middle" fill="#7ab8d8" fontSize="10" fontFamily="Inter,sans-serif" fontWeight="700">Tek Abonelik — İki Eşit Kiracı</text>

    {/* Eşit kademe dağılımı */}
    <text x="180" y="158" textAnchor="middle" fill="#3177a8" fontSize="8" fontFamily="Inter,sans-serif">120 kWh düşük</text>
    <text x="300" y="158" textAnchor="middle" fill="#7a62bd" fontSize="8" fontFamily="Inter,sans-serif">120 kWh düşük</text>
  </svg>
);

/* ─── KADEME ŞEMA (SVG bar chart) ─── */
const TieredTariffDiagram = () => (
  <svg viewBox="0 0 480 200" className="lp-svg-diagram" xmlns="http://www.w3.org/2000/svg" aria-label="Kademeli tarife öncelik şeması">
    <defs>
      <linearGradient id="lowGrad" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#2a9d5c"/>
        <stop offset="100%" stopColor="#57c994"/>
      </linearGradient>
      <linearGradient id="highGrad" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#e07a30"/>
        <stop offset="100%" stopColor="#f0a540"/>
      </linearGradient>
    </defs>

    {/* Başlıklar */}
    <text x="160" y="20" textAnchor="middle" fill="#7ab8d8" fontSize="10" fontFamily="Inter,sans-serif" fontWeight="700">Ana Kullanıcı Öncelikli</text>
    <text x="380" y="20" textAnchor="middle" fill="#b8a4ee" fontSize="10" fontFamily="Inter,sans-serif" fontWeight="700">Eşit Öncelik</text>

    {/* Sol: Ana öncelik */}
    {/* Ana kullanıcı bar */}
    <text x="30" y="50" fill="#7ab8d8" fontSize="9" fontFamily="Inter,sans-serif">Ana Kullanıcı</text>
    <text x="30" y="62" fill="#5a8aaa" fontSize="8" fontFamily="Inter,sans-serif">150 kWh</text>
    <rect x="30" y="68" width="150" height="20" rx="4" fill="url(#lowGrad)" opacity="0.85"/>
    <text x="108" y="82" textAnchor="middle" fill="#fff" fontSize="8" fontFamily="Inter,sans-serif" fontWeight="700">150 kWh — Düşük ✓</text>

    {/* Komşu bar (ana öncelikli) */}
    <text x="30" y="105" fill="#b8a4ee" fontSize="9" fontFamily="Inter,sans-serif">Komşu Süzme Sayaç</text>
    <text x="30" y="117" fill="#8070c8" fontSize="8" fontFamily="Inter,sans-serif">150 kWh</text>
    <rect x="30" y="123" width="90" height="20" rx="4" fill="url(#lowGrad)" opacity="0.7"/>
    <text x="75" y="137" textAnchor="middle" fill="#fff" fontSize="8" fontFamily="Inter,sans-serif" fontWeight="600">90 kWh</text>
    <rect x="120" y="123" width="60" height="20" rx="4" fill="url(#highGrad)" opacity="0.85"/>
    <text x="150" y="137" textAnchor="middle" fill="#fff" fontSize="8" fontFamily="Inter,sans-serif" fontWeight="700">60 kWh ⬆</text>

    {/* Kademe sınır çizgisi sol */}
    <line x1="180" y1="65" x2="180" y2="150" stroke="rgba(255,255,255,0.15)" strokeWidth="1" strokeDasharray="4,3"/>
    <text x="181" y="157" fill="rgba(255,255,255,0.35)" fontSize="7.5" fontFamily="Inter,sans-serif">240 kWh sınırı</text>

    {/* Sağ: Eşit öncelik */}
    {/* 1. kiracı bar */}
    <text x="250" y="50" fill="#7ab8d8" fontSize="9" fontFamily="Inter,sans-serif">1. Kiracı</text>
    <text x="250" y="62" fill="#5a8aaa" fontSize="8" fontFamily="Inter,sans-serif">160 kWh</text>
    <rect x="250" y="68" width="120" height="20" rx="4" fill="url(#lowGrad)" opacity="0.7"/>
    <text x="310" y="82" textAnchor="middle" fill="#fff" fontSize="8" fontFamily="Inter,sans-serif" fontWeight="600">120 kWh</text>
    <rect x="370" y="68" width="40" height="20" rx="4" fill="url(#highGrad)" opacity="0.85"/>
    <text x="390" y="82" textAnchor="middle" fill="#fff" fontSize="8" fontFamily="Inter,sans-serif" fontWeight="700">40 ⬆</text>

    {/* 2. kiracı bar */}
    <text x="250" y="105" fill="#b8a4ee" fontSize="9" fontFamily="Inter,sans-serif">2. Kiracı (Süzme)</text>
    <text x="250" y="117" fill="#8070c8" fontSize="8" fontFamily="Inter,sans-serif">140 kWh</text>
    <rect x="250" y="123" width="120" height="20" rx="4" fill="url(#lowGrad)" opacity="0.7"/>
    <text x="310" y="137" textAnchor="middle" fill="#fff" fontSize="8" fontFamily="Inter,sans-serif" fontWeight="600">120 kWh</text>
    <rect x="370" y="123" width="20" height="20" rx="4" fill="url(#highGrad)" opacity="0.85"/>
    <text x="380" y="137" textAnchor="middle" fill="#fff" fontSize="7" fontFamily="Inter,sans-serif" fontWeight="700">20</text>

    {/* Kademe sınır çizgisi sağ */}
    <line x1="370" y1="65" x2="370" y2="150" stroke="rgba(255,255,255,0.15)" strokeWidth="1" strokeDasharray="4,3"/>
    <text x="371" y="157" fill="rgba(255,255,255,0.35)" fontSize="7.5" fontFamily="Inter,sans-serif">240 kWh sınırı</text>

    {/* Legend */}
    <rect x="140" y="175" width="12" height="8" rx="2" fill="url(#lowGrad)"/>
    <text x="155" y="183" fill="#5a8aaa" fontSize="8" fontFamily="Inter,sans-serif">Düşük kademe</text>
    <rect x="240" y="175" width="12" height="8" rx="2" fill="url(#highGrad)"/>
    <text x="255" y="183" fill="#5a8aaa" fontSize="8" fontFamily="Inter,sans-serif">Yüksek kademe</text>
  </svg>
);

/* ─── DIŞA AKTARILAN BİLEŞENLER ─── */

export const AboutSubMeterSection = () => (
  <section className="lp-section" aria-labelledby="about-title">
    <div className="lp-section-header">
      <div className="lp-section-icon blue">⚡</div>
      <div>
        <h2 id="about-title">Süzme sayaç nedir?</h2>
      </div>
    </div>

    <div className="lp-schema-wrap">
      <div>
        <p>
          <strong style={{color:'#c5ddf0'}}>Ana sayaç</strong>, dağıtım şirketinin aboneliğe ait resmî faturayı oluştururken esas aldığı sayaçtır.
          Ana sayaçta görülen tüketim, bu bağlantıya bağlı bütün alanların elektrik kullanımını içerir.
        </p>
        <p>
          <strong style={{color:'#c5ddf0'}}>Süzme sayaç</strong> veya alt sayaç ise ana aboneliğe bağlı belirli bir konutun, dükkânın ya da başka bir bölümün
          tüketimini ayrı ölçer. Süzme sayaç resmî ayrı bir fatura üretmez; ortak faturanın daha adil paylaşılmasına
          yardımcı olacak tüketim bilgisini sağlar.
        </p>
        <div className="lp-callout">
          <span className="lp-callout-icon">💡</span>
          <p>
            <strong>Örnek:</strong> Ana sayaç 300 kWh, süzme sayaç 150 kWh gösteriyorsa ana kullanıcıya veya
            ortak alana kalan tüketim <strong>150 kWh</strong> olur.
          </p>
        </div>
        <p>
          Süzme Sayaç uygulaması bu değerleri seçilen tarife ve paylaşım kuralıyla değerlendirir.
          Oluşan sonuç kullanıcıların kendi aralarındaki paylaşımı kolaylaştırır; dağıtım şirketinin düzenlediği
          resmî elektrik faturasının yerine geçmez.
        </p>
      </div>
      <div className="lp-schema-img-box">
        <NeighborMeterDiagram />
      </div>
    </div>
  </section>
);

export const WhySimpleRatioIsNotEnoughSection = () => (
  <section className="lp-section" aria-labelledby="ratio-title">
    <div className="lp-section-header">
      <div className="lp-section-icon amber">⚖️</div>
      <div>
        <h2 id="ratio-title">Neden basit oran-orantı her zaman adil değildir?</h2>
      </div>
    </div>
    <p>
      Ana sayaç 300 kWh, süzme sayaç 150 kWh tüketmişse basit oran hesabı süzme sayacın toplamın %50'sini
      kullandığını söyler ve faturanın %50'sini ona verir. Bütün tüketim aynı fiyatla ücretlendirilse bu yaklaşım
      anlaşılır olabilir.
    </p>

    <div className="lp-feature-grid">
      <div className="lp-feature-card">
        <span className="fc-icon">📊</span>
        <strong>Kademeli Tarife</strong>
        <span>Her kWh aynı fiyata gelmez — belirli bir sınıra kadar düşük, sonrasında yüksek fiyat uygulanır.</span>
      </div>
      <div className="lp-feature-card">
        <span className="fc-icon">🕐</span>
        <strong>Çok Zamanlı Tarife</strong>
        <span>Gündüz, puant ve gece fiyatları birbirinden farklıdır; kimin ne zaman tükettiği önemlidir.</span>
      </div>
      <div className="lp-feature-card">
        <span className="fc-icon">🏷️</span>
        <strong>Diğer Kalemler</strong>
        <span>Dağıtım bedeli, vergi, güç bedeli — bunların paylaşım biçimi de tarife ve kurallara bağlıdır.</span>
      </div>
    </div>

    <p style={{marginTop:'1rem'}}>
      Süzme Sayaç yalnızca tüketim yüzdesini bulup faturayı aynı yüzdeyle bölmez.
      Tüketimin fiyat kademelerine dağılımını, seçilen sayaç önceliklerini ve tarifedeki ücret kalemlerini
      değerlendirebilir. Kullanıcı ister basit oranı, ister ana sayacı öncelikli tutan veya bütün kullanıcıları
      eşit öncelikte değerlendiren paylaşımı seçebilir.
    </p>
  </section>
);

export const TieredTariffExampleSection = () => (
  <section className="lp-section" aria-labelledby="tiered-title">
    <div className="lp-section-header">
      <div className="lp-section-icon purple">🏠</div>
      <div>
        <h2 id="tiered-title">Kademeli tarifede öncelik seçimi</h2>
      </div>
    </div>
    <p>
      Bu iki örnek, 30 günlük bir dönem için sistemde tanımlanmış "Tek Terim Tek Zamanlı Mesken AG" tarifesiyle
      hazırlanmış gerçek hesaplama sonuçlarıdır. Örneklerde düşük fiyatlı kademe <strong style={{color:'#c5ddf0'}}>240 kWh</strong> kabul edilmiştir.
    </p>

    {/* SVG Şema */}
    <div className="lp-schema-img-box" style={{marginBottom:'1.5rem', padding:'1.5rem 1rem'}}>
      <TieredTariffDiagram />
    </div>

    {/* SENARYO 1 */}
    <h3>🏘️ Komşumun tüketimi faturayı pahalı kademeye taşıyorsa…</h3>
    <p>
      Ana abonelik sahibi kendi bölümünde 150 kWh, komşusu da süzme sayaçla ölçülen bölümde 150 kWh tüketmiştir.
      Birlikte 300 kWh'a ulaşıldığı için faturanın 60 kWh'lık bölümü yüksek fiyatlı kademeye geçer.
    </p>

    <div className="lp-schema-img-box" style={{marginBottom:'1.25rem', padding:'1rem'}}>
      <img src="/img-neighbor-meter.png" alt="Komşu süzme sayaç bağlantı görsel şeması" style={{borderRadius:'12px', maxHeight:'240px', objectFit:'contain', width:'100%'}}/>
    </div>

    <p>
      Bu durumda <strong style={{color:'#c5ddf0'}}>ana sayaç yüksek, komşunun süzme sayacı düşük öncelikli</strong> seçilir.
      Önce ana kullanıcının 150 kWh'ı düşük kademede değerlendirilir; kalan 90 kWh'lık düşük kademe hakkı komşuya uygulanır;
      komşunun son 60 kWh'ı yüksek kademeye girer.
    </p>

    <LpTable
      caption="Ana kullanıcı öncelikli gerçek hesaplama sonucu"
      headers={['Kullanıcı','Toplam tüketim','Düşük fiyatlı kademe','Yüksek fiyatlı kademe','Toplam (vergiler dahil)']}
      rows={[
        ['Ana kullanıcı','150 kWh','150 kWh','0 kWh','485,71 TL'],
        ['Komşunun süzme sayacı','150 kWh','90 kWh','60 kWh','582,85 TL'],
        ['Toplam','300 kWh','240 kWh','60 kWh','1.068,55 TL']
      ]}
    />

    <div className="lp-callout">
      <span className="lp-callout-icon">ℹ️</span>
      <p>
        Toplama aktif enerji bedelinin yanında dağıtım bedeli, BTV, KDV ve tarifede bulunan diğer kalemler de
        paylaşım kurallarına göre dâhil edilir.
      </p>
    </div>

    <LpTable
      caption="Basit oran ve ana kullanıcı önceliği karşılaştırması"
      headers={['Yöntem','Ana kullanıcı açısından sonuç']}
      rows={[
        ['Basit %50-%50 paylaşım','Komşunun oluşturduğu pahalı kademe maliyetinin bir kısmını ana kullanıcı da ödeyebilir.'],
        ['Ana kullanıcı öncelikli paylaşım','Ana kullanıcının 150 kWh tüketimi düşük kademede kalır; pahalı bölüm komşuya ait tüketimde oluşur.']
      ]}
    />

    <div className="lp-notice">
      ⚠️ <span><strong>Öncelik sınırsız ucuz tarife hakkı değildir.</strong> Ana kullanıcı tek başına 260 kWh tüketirse ilk 240 kWh düşük, kendi kalan 20 kWh'ı yüksek kademeden hesaplanır. Ardından değerlendirilen komşu için düşük kademe hakkı kalmadıysa komşunun tüketiminin tamamı yüksek kademeye girebilir.</span>
    </div>

    {/* SENARYO 2 */}
    <h3>🏢 Aynı aboneliği eşit haklarla kullanan iki kiracı</h3>
    <p>
      Tek elektrik aboneliği bulunan bir villanın iki bağımsız bölümünde iki kiracının yaşadığını düşünelim.
      Abonelik taraflardan birinin adına görünse de kullanım ilişkilerinde ikisi de <strong style={{color:'#c5ddf0'}}>eşit hakka</strong> sahiptir.
    </p>

    <div className="lp-schema-img-box" style={{marginBottom:'1.25rem', padding:'1rem'}}>
      <img src="/img-equal-tenants.png" alt="Eşit öncelikli iki kiracı görsel şeması" style={{borderRadius:'12px', maxHeight:'240px', objectFit:'contain', width:'100%'}}/>
    </div>

    <div className="lp-schema-img-box" style={{marginBottom:'1.25rem', padding:'1.5rem 1rem'}}>
      <EqualTenantsDiagram />
    </div>

    <p>
      Birinci kiracı 160 kWh, ikinci kiracı 140 kWh tüketmiştir. <strong style={{color:'#c5ddf0'}}>Eşit öncelik</strong> seçildiğinde
      düşük fiyatlı 240 kWh'lık hak iki kiracıya <strong style={{color:'#c5ddf0'}}>120'şer kWh</strong> olarak dağıtılır.
    </p>

    <LpTable
      caption="İki kiracı eşit öncelikli gerçek hesaplama sonucu"
      headers={['Kullanıcı','Toplam tüketim','Düşük fiyatlı kademe','Yüksek fiyatlı kademe','Toplam (vergiler dahil)']}
      rows={[
        ['Birinci kiracı / ana sayaçta kalan','160 kWh','120 kWh','40 kWh','582,85 TL'],
        ['İkinci kiracı / süzme sayaç','140 kWh','120 kWh','20 kWh','485,71 TL'],
        ['Toplam','300 kWh','240 kWh','60 kWh','1.068,55 TL']
      ]}
    />

    <div className="lp-callout">
      <span className="lp-callout-icon">📌</span>
      <p>
        <strong>Eşit öncelik faturayı eşit bölmek değildir;</strong> düşük fiyatlı kademeden eşit yararlanma hakkıdır.
        Birinci kiracının 40 kWh'ı, ikinci kiracının 20 kWh'ı yüksek kademeye geçtiği için toplam ödemeleri farklıdır.
      </p>
    </div>

    <LpTable
      caption="Basit oran ve eşit öncelik karşılaştırması"
      headers={['Yaklaşım','Ne yapar?']}
      rows={[
        ['Basit oran','Toplam faturayı yalnızca toplam kWh oranına göre böler.'],
        ['Eşit öncelikli tarife hesabı','Düşük kademe hakkını eşit dağıtır; herkesin kademe üstündeki tüketimini ayrıca hesaplar.']
      ]}
    />

    <h3>📋 Aynı tarife, farklı paylaşım kuralı</h3>
    <LpTable
      caption="Kullanım ilişkisine göre öncelik seçenekleri"
      headers={['Kullanım şekli','Uygun öncelik','Düşük kademe nasıl kullanılır?']}
      rows={[
        ['Ana abonelik sahibinin komşusuna elektrik vermesi','Ana kullanıcı öncelikli','Önce ana kullanıcı, sonra kalan hakla komşu hesaplanır.'],
        ['Aynı aboneliği eşit haklarla paylaşan iki kiracı','Eşit öncelik','Düşük kademe kullanıcılar arasında eşit hakla paylaştırılır.'],
        ['Yalnızca basit paylaşım istenmesi','Oransal paylaşım','Fatura tüketim oranlarına göre dağıtılır; kademeyi kimin oluşturduğu ayrıca değerlendirilmez.']
      ]}
    />

    <p>Tek yöntem her ilişki için adil olmayabilir. Süzme Sayaç, düşük fiyatlı kademeden hangi sırayla veya hangi
       hakla yararlanılacağını seçmeye imkân vererek paylaşım kuralını gerçek kullanım ilişkisine uyarlamaya yardımcı olur.</p>
    <div className="lp-notice">⚠️ <span>{tariffNotice}</span></div>
  </section>
);

export const TimeOfUseExampleSection = () => (
  <section className="lp-section" aria-labelledby="time-title">
    <div className="lp-section-header">
      <div className="lp-section-icon teal">🕒</div>
      <div>
        <h2 id="time-title">Çok zamanlı tarifede tüketim saatleri neden önemlidir?</h2>
      </div>
    </div>
    <p>
      <strong style={{color:'#c5ddf0'}}>Endeks</strong>, sayacın gündüz, puant veya gece gibi ayrı zaman dilimleri için tuttuğu tüketim değeridir.
      Çok zamanlı tarifede sistem gündüz tüketimini gündüz, puant tüketimini puant ve gece tüketimini gece fiyatıyla
      değerlendirmeye yardımcı olur.
    </p>
    <div className="lp-feature-grid">
      <div className="lp-feature-card">
        <span className="fc-icon">☀️</span>
        <strong>Gündüz</strong>
        <span>Gündüz endeksindeki tüketim ve fiyat kullanılır.</span>
      </div>
      <div className="lp-feature-card">
        <span className="fc-icon">⚡</span>
        <strong>Puant</strong>
        <span>Yoğun kullanım saatlerine ait tüketim ayrı değerlendirilir.</span>
      </div>
      <div className="lp-feature-card">
        <span className="fc-icon">🌙</span>
        <strong>Gece</strong>
        <span>Gece endeksi kendi tarife fiyatıyla hesaplanır.</span>
      </div>
    </div>
    <div className="lp-callout" style={{marginTop:'1rem'}}>
      <span className="lp-callout-icon">💡</span>
      <p>
        İki kullanıcı toplamda 100'er kWh tüketse bile biri ağırlıklı olarak puant, diğeri gece tüketmişse
        maliyetleri farklı olabilir. Bu nedenle yalnızca toplam 200 kWh üzerinden oran kurmak yanıltıcıdır.
      </p>
    </div>
  </section>
);

export const LateReadingExampleSection = () => (
  <section className="lp-section" aria-labelledby="late-title">
    <div className="lp-section-header">
      <div className="lp-section-icon amber">📅</div>
      <div>
        <h2 id="late-title">Sayaç geç okunursa tüketim nasıl yönetilebilir?</h2>
      </div>
    </div>
    <div className="lp-schema-wrap">
      <div>
        <p>
          Fatura dönemi 30 günken süzme sayaç 40 gün sonra okunmuş ve 200 kWh tüketim göstermiş olsun.
          Günlük ortalama 200 ÷ 40 = <strong style={{color:'#c5ddf0'}}>5 kWh</strong>'tır.
        </p>
        <p>
          Mevcut faturaya <strong style={{color:'#c5ddf0'}}>30 × 5 = 150 kWh</strong> alınabilir; kalan 50 kWh sonraki döneme bırakılabilir.
        </p>
        <div className="lp-notice">
          ⚠️ <span>Bu yaklaşım oransal bir yöntemdir; en doğru sonuç bütün sayaçların aynı tarihte okunmasıyla elde edilir.</span>
        </div>
      </div>
      <div>
        <LpTable
          caption="40 günlük geç okuma örneği"
          headers={['Açıklama','Değer']}
          rows={[
            ['40 günlük toplam tüketim','200 kWh'],
            ['Günlük ortalama','5 kWh'],
            ['Mevcut 30 günlük faturaya alınan','150 kWh'],
            ['Sonraki döneme bırakılan','50 kWh']
          ]}
        />
      </div>
    </div>
  </section>
);

export const RecordManagementSection = () => (
  <section className="lp-section" aria-labelledby="records-title">
    <div className="lp-section-header">
      <div className="lp-section-icon green">🗂️</div>
      <div>
        <h2 id="records-title">Her ay eski sayaç değerlerini yeniden aramayın</h2>
      </div>
    </div>
    <p>
      Giriş yapan kullanıcı faturalarını, ana ve süzme sayaç okumalarını ve okuma tarihlerini birlikte kaydedebilir.
      Yeni okuma girildiğinde önceki endeks sistemde bulunduğu için dönem tüketimi otomatik hesaplanabilir.
    </p>
    <ul className="lp-benefit-list">
      <li>Fatura ve sayaç kayıtları aynı yerde takip edilir.</li>
      <li>Paylaşım tek işlemle oluşturulabilir.</li>
      <li>Geçmiş dönem sonuçlarına yeniden ulaşılabilir ve dönemler karşılaştırılabilir.</li>
      <li>Excel, kâğıt veya mesaj geçmişinden eski değer arama ihtiyacı azalır.</li>
      <li>Geç okuma gibi istisnai dönemler daha düzenli yönetilebilir.</li>
    </ul>
    <p style={{marginTop:'1rem'}}>
      Sonuç ekranı yalnızca nihai tutarı değil; ana kullanıcının ve her süzme sayacın tüketimini, oranını ve
      hesaplanan payını görünür hâle getirerek paylaşımın taraflara açıklanmasını kolaylaştırır.
    </p>
  </section>
);

const caseIcons = ['🏠','🌱','🏪','🏢','👨‍👩‍👧','🏗️'];
const cases = [
  ['Kiracı ve ev sahibi','Aynı abonelikte farklı alanları kullanan tarafların tüketimlerini ayırmak için.'],
  ['Hobi bahçeleri','Ortak ana aboneliğe bağlı bahçelerin kendi tüketimlerini hesaplamak için.'],
  ['İş yerleri','Aynı bağlantıyı kullanan bağımsız bölüm, ofis, dükkân veya atölyelerin paylaşımı için.'],
  ['Apartman ortak alanları','Daire, görevli dairesi, asansör veya ortak alan tüketimlerini ayırmak için.'],
  ['Aile üyeleri ve komşular','Aynı aboneliği paylaşan kullanıcıların tüketimlerini daha şeffaf görmek için.'],
  ['Depo ve müştemilat','Ana binaya bağlı ek alanların tüketimini ayrı izlemek için.']
];

export const UseCasesSection = () => (
  <section className="lp-section" aria-labelledby="uses-title">
    <div className="lp-section-header">
      <div className="lp-section-icon purple">👥</div>
      <div>
        <h2 id="uses-title">Kimler kullanabilir?</h2>
      </div>
    </div>
    <div className="lp-usecase-grid">
      {cases.map(([title, text], i) => (
        <div key={title} className="lp-usecase-card">
          <span className="uc-icon">{caseIcons[i]}</span>
          <h3>{title}</h3>
          <p>{text}</p>
        </div>
      ))}
    </div>
  </section>
);

const mistakes = [
  ['Farklı tarihlerde okuma','Ana ve süzme sayaçları farklı günlerde okumak aynı dönemi karşılaştırmayı zorlaştırır.'],
  ['Endeks ve tüketimi karıştırma','Sayacın birikimli yeni endeksi ile dönem tüketimi aynı değer değildir.'],
  ['Zaman dilimlerini karıştırma','Gündüz, puant ve gece değerleri faturadaki karşılıklarıyla girilmelidir.'],
  ['Alt sayaç toplamının ana sayacı aşması','Tarihler, endeksler ve sayaç bağlantıları yeniden kontrol edilmelidir.'],
  ['Sayaç çarpanını atlama','Sayaçta bir çarpan kullanılıyorsa gerçek tüketim buna göre bulunmalıdır.'],
  ['Tek birim fiyat kullanma','Kademeli tarifede bütün tüketimi tek fiyatla hesaplamak sonucu bozabilir.'],
  ['Önceki endeksi yanlış hatırlama','Kayıtlı okumalar hesap farklarının önüne geçmeye yardımcı olur.'],
  ['Paylaşım kuralını belirlememe','Dağıtım, vergi, sabit ve güç bedellerinin nasıl paylaşılacağı önceden netleştirilmelidir.']
];

export const CommonMistakesSection = () => (
  <section className="lp-section" aria-labelledby="mistakes-title">
    <div className="lp-section-header">
      <div className="lp-section-icon rose">⚠️</div>
      <div>
        <h2 id="mistakes-title">Sık yapılan hatalar</h2>
      </div>
    </div>
    <ul className="lp-mistake-list">
      {mistakes.map(([title, text]) => (
        <li key={title}><strong>{title}:</strong> {text}</li>
      ))}
    </ul>
  </section>
);

const faqs = [
  ['Süzme sayaç nedir?','Süzme sayaç, ana elektrik aboneliğine bağlı belirli bir alanın veya kullanıcının tüketimini ayrı ölçen alt sayaçtır. Değerleri ortak elektrik faturasının taraflar arasında paylaşılmasına yardımcı olur; kendisi resmî fatura üretmez.'],
  ['Alt sayaç ile süzme sayaç aynı şey midir?','Günlük kullanımda bu iki ifade çoğunlukla aynı amaçla kullanılır: ana aboneliğin altındaki tüketimi ayrı izlemek. Sayacın tesisata uygunluğu, çarpanı veya teknik bağlantısı konusunda yetkili elektrik uzmanına danışılmalıdır.'],
  ['Süzme sayaç resmî fatura oluşturur mu?','Hayır. Resmî fatura dağıtım veya görevli tedarik şirketi tarafından ana abonelik için düzenlenir. Uygulamanın sonucu kullanıcıların kendi aralarındaki paylaşımı kolaylaştırır ve resmî faturanın yerine geçmez.'],
  ['Ana sayaçta kalan tüketim nasıl hesaplanır?','Aynı okuma dönemindeki süzme sayaç tüketimleri ana sayaç toplamından çıkarılır. Ana sayaç 300 kWh ve süzme sayaç toplamı 150 kWh ise ana kullanıcıya veya ortak alana 150 kWh kalır.'],
  ['Neden faturayı sadece kWh oranına göre bölmek her zaman adil değildir?','Tüm kWh değerleri aynı fiyatla ücretlendirilmeyebilir. Kademeler, gündüz-puant-gece fiyatları, vergiler, dağıtım ve diğer ücret kalemleri maliyeti değiştirir; basit oran bu farkların kimden kaynaklandığını göstermez.'],
  ['Kademeli tarifede düşük fiyatlı tüketimi kimin kullanacağı seçilebilir mi?','Evet. Ana sayaç süzme sayaçlardan daha öncelikli seçilebilir veya bütün kullanıcılar eşit öncelikte değerlendirilebilir. Süzme sayaç ana sayaçtan daha öncelikli yapılamaz; öncelik seçimi de sınırsız düşük fiyat hakkı sağlamaz.'],
  ['Komşum benim elektrik aboneliğimi kullanıyorsa faturayı nasıl paylaşabilirim?','Komşunun tüketimi ayrı süzme sayaçla ölçülebilir. Ana abonelik sahibi kendi tüketiminin komşu nedeniyle pahalı kademeye geçmesini istemiyorsa ana sayacı yüksek, komşunun sayacını düşük öncelikli seçebilir; önce ana tüketim, sonra kalan kademe hakkına göre komşu hesaplanır.'],
  ['Düşük öncelikli sayaç ne demektir?','Düşük fiyatlı tüketim hakkı dağıtılırken diğer sayaçlardan sonra değerlendirilen sayaçtır. Kademe hakkı kalmışsa bundan yararlanır; kalmamışsa tüketiminin tamamı yüksek fiyatlı kademede hesaplanabilir.'],
  ['Ana sayaç öncelikli seçilirse ana kullanıcı hiç yüksek tarife ödemez mi?','Hayır. Ana kullanıcının kendi tüketimi tek başına kademe sınırını aşarsa sınırın üzerindeki tüketimi yüksek fiyatla hesaplanır. Öncelik yalnızca düşük kademenin hangi sırayla kullanılacağını belirler.'],
  ['Aynı aboneliği paylaşan iki kiracı için hangi yöntem kullanılabilir?','Taraflar eşit haklara sahipse eşit öncelik seçilebilir. Düşük fiyatlı kademe hakkı kullanıcılar arasında eşit dağıtılır; her kullanıcı kendi hakkını aşan tüketimini yüksek fiyatlı kademeden öder.'],
  ['Eşit öncelik faturayı eşit bölmek anlamına mı gelir?','Hayır. Eşit olan, düşük fiyatlı kademeden yararlanma hakkıdır. Kullanıcıların toplam tüketimleri farklıysa yüksek kademedeki tüketimleri ve toplam ödemeleri de farklı olabilir.'],
  ['Faturanın yarısını tüketen kişi her zaman faturanın yarısını mı öder?','Hayır. Bütün kWh değerleri aynı fiyatla ücretlendirilmiyorsa veya kullanıcıların kademe öncelikleri farklıysa aynı tüketim oranı farklı maliyet doğurabilir. Basit %50-%50 yöntemi pahalı kademeyi hangi kullanıcının oluşturduğunu dikkate almaz.'],
  ['Ana sayaç ve süzme sayaç aynı miktarda tüketirse neden farklı tutar çıkabilir?','Sayaçlardan birinin tüketiminin daha büyük bölümü yüksek fiyatlı kademeye yerleşmiş olabilir. Aynı kWh miktarı farklı kademelerden hesaplandığında aktif enerji, dağıtım ve vergi bileşenleriyle birlikte farklı tutara ulaşabilir.'],
  ['Çok zamanlı tarifede hangi değerleri girmeliyim?','Faturadaki gündüz, puant ve gece endeksleri ayrı ayrı girilmelidir. Ana ve süzme sayaçların aynı tarih aralığında ve aynı endeks türleriyle okunması karşılaştırmanın doğruluğunu artırır.'],
  ['Dağıtım bedeli ve vergiler de paylaştırılıyor mu?','Hesaplama, sistemde tanımlı tarife yapısına göre aktif enerji, dağıtım, BTV, KDV ve ilgili diğer kalemleri dikkate alabilir. Her kalemin dağılımı seçilen tarife ve paylaşım kuralına bağlıdır.'],
  ['Sabit bedeller, sözleşme gücü veya güç aşım bedeli nasıl paylaştırılır?','Bu bedeller tüketimden farklı bir paylaşım kuralı gerektirebilir. Uygulamada sunulan seçenekler ve tanımlı tarife kullanılır; tarafların seçimi gerçek sözleşme koşullarıyla karşılaştırması gerekir.'],
  ['Fatura ve sayaç değerleri sistemde saklanabilir mi?','Giriş yapan kullanıcılar faturalarını, ana ve süzme sayaç okumalarını ve tarihlerini yönetebilir. Böylece geçmiş dönem kayıtları ve önceki endeksler sonraki hesaplamalarda düzenli biçimde kullanılabilir.'],
  ['Her ay önceki sayaç endeksini tekrar girmek gerekir mi?','Kayıtlı kullanımda önceki okuma sistemde tutulabildiği için yeni endeks girildiğinde dönem tüketimi hesaplanabilir. Ücretsiz hızlı hesaplama ise kayıt yönetiminden bağımsız, tek seferlik sonuç almaya yöneliktir.'],
  ['Sayaç geç okunursa tüketim nasıl hesaplanır?','Uzun dönemdeki tüketim gün sayısına bölünerek günlük ortalama bulunabilir ve fatura dönemine düşen tahmini bölüm hesaplanabilir. Bu oransal bir yaklaşımdır; bütün sayaçları aynı gün okumak daha doğru sonuç verir.'],
  ['Fazla okunan tüketim sonraki aya bırakılabilir mi?','Geç okuma yönetiminde fatura dönemi dışındaki tahmini tüketim sonraki döneme bırakılabilir. Böylece uzun dönemin tamamı tek faturaya yüklenmez; sonuçların tahmini olduğu taraflara açıkça anlatılmalıdır.'],
  ['Süzme sayaçların toplamı ana sayaç tüketimini geçerse ne yapılmalıdır?','Okuma tarihleri, önceki ve yeni endeksler, sayaç çarpanları ve bağlantılar yeniden kontrol edilmelidir. Sorun çözülmeden paylaşım yapılmamalı; gerekirse yetkili elektrik uzmanından destek alınmalıdır.'],
  ['Hesaplama sonucu neden resmî faturayla birebir aynı olmayabilir?','Yuvarlama, güncel tarife tanımları, vergi, dağıtım, sabit veya güç bedelleri ve farklı okuma dönemleri sonucu etkileyebilir. Uygulama paylaşım desteği sağlar, resmî fatura düzenlemez.'],
  ['Hesaplamayı yaptıktan sonra sonucu tekrar görebilir miyim?','Giriş yapan kullanıcı geçmiş fatura, sayaç ve paylaşım kayıtlarını yönetebilir ve önceki dönemlere yeniden ulaşabilir. Kayıtların kapsamı kullanılan özelliklere ve girilen verilere bağlıdır.'],
  ['Veriler saklanıyor mu?','Ücretsiz hesaplama girdileri hizmetin çalışması için işlenir; giriş yapılan kayıt yönetiminde kullanıcı tarafından kaydedilen veriler hesap geçmişi için tutulabilir. Ayrıntılı bilgi için Gizlilik Politikası incelenmelidir.'],
  ['Ücretsiz hesaplama ile giriş yaptıktan sonraki kullanım arasında ne fark vardır?','Ücretsiz araç, tarife ve tüketim değerleriyle hızlı bir paylaşım sonucu oluşturur. Giriş yapan kullanıcı ayrıca fatura ve sayaç kayıtlarını yönetebilir, önceki okumaları kullanabilir, geçmiş dönemleri takip edebilir ve paylaşımı daha düzenli sürdürebilir.']
];

export const FaqSection = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.id = 'faq-structured-data';
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqs.map(([name, text]) => ({ '@type': 'Question', name, acceptedAnswer: { '@type': 'Answer', text } }))
    });
    document.getElementById(script.id)?.remove();
    document.head.appendChild(script);
    return () => script.remove();
  }, []);

  return (
    <section className="lp-section lp-faq-section" aria-labelledby="faq-title">
      <div className="lp-section-header">
        <div className="lp-section-icon blue">❓</div>
        <div>
          <h2 id="faq-title">Sık Sorulan Sorular</h2>
        </div>
      </div>
      {faqs.map(([question, answer], index) => (
        <Accordion key={question} disableGutters elevation={0}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls={`faq-${index}-content`} id={`faq-${index}-header`}>
            <Typography component="h3" fontWeight={600} style={{color:'#c5ddf0', fontSize:'0.95rem'}}>{question}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography style={{color:'#7a9db8', fontSize:'0.9rem', lineHeight:'1.7'}}>{answer}</Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </section>
  );
};
